module.exports = __webpack_public_path__ + "img/thumbnail_BlackWildebeest_m_albino.cf77e23f.png";